<template>
  <b-alert v-model="showAlert" variant='warning' dismissible class="alert warning-alert">
    {{ message }}
  </b-alert>
</template>

<style scoped>

.alert {
  position: fixed;
  bottom: 1%;
  z-index: 2000;
  left: 3%;
  right: 3%;
}

.warning-alert {
  margin-top: 16px;
  color: #856404 !important;
  background-color: #fff3cd !important;
  border-color: #d5c48e !important;
}

</style>

<script>

import EventBus from '../EventBus';

export default {
  name: 'WarningAlert',
  components: {},
  data () {
    return {
      message: '',
      showAlert: false
    };
  },
  computed: {},
  mounted () {
    EventBus.$on('show-warning-alert', this.showWarningAlert);
  },
  beforeDestroy () {
    EventBus.$off('show-warning-alert', this.showWarningAlert);
  },
  methods: {
    showWarningAlert: function (message) {
      this.message = message;
      this.showAlert = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Alerts/WarningAlert.vue